export enum CandidateType {
	TALENTS_ARENA = 'talents_arena',
	ACPC = 'acpc',
	PSUT = 'psut'
}
